import { translate } from 'services/i18n';

import type { Contact } from '../../../domain/contact';
import { appStore } from '../../../services/appStore';
import { contactsApi } from '../api';
import type { ContactRepository } from '../repository';

import type { RevealContactRepository } from './useCase';

export const makeRevealContactRepository = (contactRepository: ContactRepository): RevealContactRepository => ({
  getPrivateData: (contact: Contact) => contactsApi.getPrivateData(contact),
  getBulkPrivateData: (contacts: Contact[]) => contactsApi.getBulkPrivateData(contacts),
  getBulkRevealStatus: (requestId: string) => contactsApi.getBulkRevealStatus(requestId),
  showLoadingToast: (count: number) => {
    appStore.setToast({
      content: translate('contacts.bulk_reveal.loading', { count }),
      isLoading: true,
      showCloseIcon: false,
    });
  },
  showSuccessToast: () => {
    appStore.setSuccessToast({
      content: translate('contacts.bulk_reveal.success'),
      showCloseIcon: true,
    });
  },
  showPartialSuccessToast: ({ totalCount, successCount }: { totalCount: number; successCount: number }) => {
    appStore.setSuccessToast({
      content: translate('contacts.bulk_reveal.success_partial', {
        totalCount,
        successCount,
      }),
      showCloseIcon: true,
    });
  },
  showErrorToast: () => {
    appStore.setErrorToast({
      content: translate('contacts.bulk_reveal.failed'),
      showCloseIcon: true,
    });
  },
  addNotRevealedContactId: (contactId: string) => appStore.addNotRevealedContactId(contactId),
  ...contactRepository,
});
